import React, { useState, useRef, useEffect } from 'react';
import safetyImage from '../../images/safety_image.jpeg';
import worker from "../../images/character-worker.svg";
import check from "../../images/icon-whitecheck.svg";
import safetyCap from "../../images/safety-cap.svg";
import safetyBelt from "../../images/safety-belt.svg";
import safetyShoes from "../../images/safety-shoes.svg";
import {
    BigPlayButton,
    ControlBar,
    CurrentTimeDisplay, DurationDisplay, FullscreenToggle,
    LoadingSpinner, PlaybackRateMenuButton,
    Player,
    PlayToggle,
    TimeDivider
} from "video-react";
import axios from "axios";

export default function SecondStep({ setTab, tab, checked, setChecked, btnRef, fn_loginStrtBtn, snackbarTxt, setSnackbarTxt }: any) {
    const videoRef = useRef<any>();
    const [eduData, setEduData] = useState<any>([]);
    const [sftyEduDtlData, setSftyEduDtlData] = useState({});

    useEffect(() => { if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 2000) } }, [snackbarTxt]);

    const nextHandler = () => {
        setTab(tab + 1);
    };
    const doneHandler = async () => {
        if (videoRef.current && !videoRef.current.getState().player.ended) {
            setSnackbarTxt('영상을 끝까지 시청해주세요.');
            return;
        }
        fn_loginStrtBtn();
    };
    const checkHandler = (equip: string) => {
        setChecked((prevState: any) => ({ ...prevState, [equip]: !checked[equip] }));
    };

    const retrieveForeignerSftyEdu = async (setSftyEduDtlData: any) => {
        let rtrnData = await axios.post('admin/api/tbm/retrieveBrdDataByForeigner');
        if(rtrnData.data.length > 0){
            setSftyEduDtlData(rtrnData.data[0]);
        }
    }

    const fn_retrieveVideoData = async (sftyEduDtlData: any) => {
        let dataAtchFileId = sftyEduDtlData.atchFileId
        const rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', { atchFileId: dataAtchFileId });
        let datas = rtrnData.data.fileList
        for (let i in datas) {
            datas[i].videoUrl = `admin/api/cmmn/fileDownload?atchFileId=${datas[i].atchFileId}&fileSn=${datas[i].fileSn}`
        }
        setEduData(datas);

        console.log(eduData)
    }

    useEffect(() => {
        retrieveForeignerSftyEdu(setSftyEduDtlData);
    }, [])

    useEffect(() => {
        if (sftyEduDtlData) {
            fn_retrieveVideoData(sftyEduDtlData);
        }
    }, [sftyEduDtlData])

    return (
        <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-117px)] md:h-[calc(100%-380px)]'>
            {tab === 2 &&
                <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px] '>
                    <div className='w-[90%] flex flex-col justify-center mt-20 md:text-37'>
                        <img alt='file'
                             src={safetyImage}
                             className='object-cover'/>
                    </div>
                </div>}
            {tab === 3 &&
                <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px]'>
                    <div
                        className='flex flex-col items-center my-24 py-12 md:my-[60px] md:py-[30px] w-full bg-[#FFEEEF] rounded-[5px] md:rounded-[12px] text-15 leading-17 md:text-35 md:leading-42'>
                        <p>Check the protective gear required</p>
                        <p className='font-preBold my-7'>for the operation and</p>
                        <p className='font-preBold my-7'>select the protective gear you wear.</p>
                        <p className='text-point font-preBold'>※ Safety helmets are required.</p>
                    </div>
                    <div className='flex w-full relative'>
                        <img src={worker} alt='worker'
                             className='w-120 h-[285px] md:w-[300px] md:h-[712px] absolute z-10 top-45 md:top-[112px]'/>
                        <div className='flex flex-col w-full items-end z-20'>
                            <div className='flex items-center'>
                                <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point'/>
                                <div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point'/>
                                <div
                                    className={`w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center mb-19 md:mb-[47px] relative ${checked['cap'] && 'border border-point'}`}>
                                    {checked['cap'] && <>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full rounded-[5px] md:rounded-[12px] bg-black opacity-[0.45]'></div>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full'>
                                            <img src={check} alt='check'/></div>
                                    </>}
                                    <img src={safetyCap} alt='cap'
                                         className='w-68 h-77 md:w-[150px] md:h-[180px]'/><p
                                    className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전모</p>
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point'/>
                                <div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point'/>
                                <div onClick={() => checkHandler('belt')}
                                     className={`w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center mb-19 md:mb-[47px] relative ${checked['belt'] && 'border border-point'}`}>
                                    {checked['belt'] && <>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full rounded-[5px] md:rounded-[12px] bg-black opacity-[0.45]'></div>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full'>
                                            <img src={check} alt='check'/></div>
                                    </>}
                                    <img src={safetyBelt} alt='belt'
                                         className='w-86 h-73 md:w-[160px] md:h-[180px]'/><p
                                    className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전대/벨트</p>
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <div className='w-7 h-7 md:w-[17px] md:h-[17px] rounded-full bg-point'/>
                                <div className='w-61 md:w-[180px] border border-x-0 border-t-0 border-point'/>
                                <div onClick={() => checkHandler('shoes')}
                                     className={`w-[206px] h-103 md:w-[450px] md:h-[257px] rounded-[5px] md:rounded-[12px] bg-[#F5F6F8] border border-[#C9C9C9] flex justify-evenly items-center relative ${checked['shoes'] && 'border border-point'}`}>
                                    {checked['shoes'] && <>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full rounded-[5px] md:rounded-[12px] bg-black opacity-[0.45]'></div>
                                        <div
                                            className='absolute flex justify-center items-center w-full h-full'>
                                            <img src={check} alt='check'/></div>
                                    </>}
                                    <img src={safetyShoes} alt='shoes'
                                         className='w-85 h-52 md:w-[160px] md:h-[180px]'/><p
                                    className='text-14 leading-17 md:text-35 md:leading-42 font-preBold'>안전화</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            {tab === 4 &&
                <div className='flex flex-col justify-center items-center w-[260px] sm:w-[318px] md:w-[750px]'>
                    <div className='w-[100%] flex justify-between items-center mt-30'>
                        {eduData.map((data: any) => (
                            <Player autoPlay playsInline key={data.fileSn} ref={videoRef} >
                                <source src={data?.videoUrl} type="video/mp4" />
                                <LoadingSpinner />
                                <BigPlayButton position="center" />
                                <ControlBar autoHide={false} disableDefaultControls={true}>
                                    <PlayToggle />
                                    <CurrentTimeDisplay order={1} className='-translate-x-10' />
                                    <TimeDivider order={1} className='-translate-x-15' />
                                    <DurationDisplay order={1} className='-translate-x-21' />
                                    <PlaybackRateMenuButton rates={[1, 1.5, 2]} />
                                    <FullscreenToggle actions={true} />
                                </ControlBar>
                            </Player>
                        ))}
                    </div>
                </div>}
            <button onClick={tab !== 4 ? nextHandler : doneHandler} ref={btnRef}
                    className='text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto pt-10 pb-10 mb-20 md:pt-[25px] md:pb-[25px] md:mb-[50px]'>
                Checked it.
            </button>
        </div>
    );
};